import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { GET_DATE_RANGE } from '../../query/monitor/keys';
import { DateRange } from '../../../models/monitor/DateRange';
import { getDateRange } from '../../services/monitor/MonitorService';

export const useGetDateRange = (projectId: number | null) => {
  const queryClient = useQueryClient();
  const queryEnabled = !!projectId;

  const {
    data: dateRange,
    isLoading,
    isError,
    error,
  } = useQuery<DateRange>({
    queryKey: [GET_DATE_RANGE, projectId],
    queryFn: () => getDateRange(projectId!),
    staleTime: 1000 * 60 * 60 * 6,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: queryEnabled,
  });

  const refreshMutation = useMutation({
    mutationFn: () => getDateRange(projectId!),
    onSuccess: (data) => {
      queryClient.setQueryData([GET_DATE_RANGE, projectId], data);
    },
  });

  return {
    dateRange,
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
    refresh: refreshMutation.mutate,
    isRefreshing: refreshMutation.isPending,
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: [GET_DATE_RANGE, projectId],
        refetchType: 'active',
      }),
  };
};
